import { useFlashSale } from '@/containers/FlashSaleContainer'
import { useEffect, useState } from 'react'

interface CountdownType {
  endTime: number
  type: string
  productId: string
  className?: string
}
const Countdown = ({ endTime, type, productId, className }: CountdownType) => {
  const { dispatch } = useFlashSale()
  const savedTime = new Date(endTime)
  const countDownDate = new Date(savedTime).getTime()
  const [countDown, setCountDown] = useState(
    countDownDate - new Date().getTime()
  )
  const [days, setDays] = useState(0)
  const [hours, setHours] = useState(0)
  const [minutes, setMinutes] = useState(0)
  const [seconds, setSeconds] = useState(0)

  useEffect(() => {
    setDays(Math.floor(countDown / (1000 * 60 * 60 * 24)))
    setHours(
      Math.floor(
        (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60) + days * 24
      )
    )
    setMinutes(Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60)))
    setSeconds(Math.floor((countDown % (1000 * 60)) / 1000))
  }, [countDown])
  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime())
      if (countDownDate - new Date().getTime() < 0) {
        setDays(0)
        setHours(0)
        setMinutes(0)
        setSeconds(0)
        setCountDown(0)
        dispatch({
          type: 'DELETE_PRODUCT',
          payload: {
            productId,
          },
        })
        clearInterval(interval)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [countDownDate])
  return (
    <div
      className={`countDown flex pl-5 items-center z-[49] text-fieldLabel font-bold text-white ${
        type == 'product-detail'
          ? 'relative justify-center gap-x-[4px] h-[32px]'
          : 'absolute left-2 px-2 bottom-0 gap-[3px] h-[21px] justify-start !text-[12px]'
      } ${className}`}
    >
      {hours < 10 ? (
        <div
          className={`${
            type == 'product-detail'
              ? 'h-[32px] w-[32px] text-[18px] bg-[#000000] rounded'
              : 'h-full'
          } formCountTime flex items-center justify-center `}
        >
          <span className={'block'}>0</span>
          <span className={'block'}>{hours}</span>
        </div>
      ) : hours >= 24 ? (
        <div
          className={`${
            type == 'product-detail'
              ? 'h-[32px] w-[32px] text-[18px] bg-[#000000] rounded'
              : 'h-full'
          } formCountTime flex items-center justify-center `}
        >
          {hours % 24 > 10 ? (
            <>
              <span className={'block'}>{`${hours % 24}`?.charAt(0)}</span>
              <span className={'block'}>{`${hours % 24}`?.charAt(1)}</span>
            </>
          ) : (
            <>
              <span className={'block'}>0</span>
              <span className={'block'}>{`${hours % 24}`?.charAt(0)}</span>
            </>
          )}
        </div>
      ) : (
        <div
          className={`${
            type == 'product-detail'
              ? 'h-[32px] w-[32px] text-[18px] bg-[#000000] rounded'
              : 'h-full'
          } formCountTime flex items-center justify-center `}
        >
          <span className={'block'}>{`${hours}`?.charAt(0)}</span>
          <span className={'block'}>{`${hours}`?.charAt(1)}</span>
        </div>
      )}
      <span
        className={`${
          type == 'product-detail' ? '' : ''
        } delimiter`}
      >
        :
      </span>
      {minutes < 10 ? (
        <div
          className={`${
            type == 'product-detail'
              ? 'h-[32px] w-[32px] text-[18px] bg-[#000000] rounded'
              : 'h-full'
          } formCountTime flex items-center justify-center `}
        >
          <span className={'block'}>0</span>
          <span className={'block'}>{minutes}</span>
        </div>
      ) : (
        <div
          className={`${
            type == 'product-detail'
              ? 'h-[32px] w-[32px] text-[18px] bg-[#000000] rounded'
              : 'h-full'
          } formCountTime flex items-center justify-center `}
        >
          <span className={'block'}>{`${minutes}`?.charAt(0)}</span>
          <span className={'block'}>{`${minutes}`?.charAt(1)}</span>
        </div>
      )}
      <span
        className={`${
          type == 'product-detail' ? '' : ''
        } delimiter`}
      >
        :
      </span>
      {seconds < 10 ? (
        <div
          className={`${
            type == 'product-detail'
              ? 'h-[32px] w-[32px] text-[18px] bg-[#000000] rounded'
              : 'h-full'
          } formCountTime flex items-center justify-center `}
        >
          <span className={'block'}>0</span>
          <span className={'block'}>{seconds}</span>
        </div>
      ) : (
        <div
          className={`${
            type == 'product-detail'
              ? 'h-[32px] w-[32px] text-[18px] bg-[#000000] rounded'
              : 'h-full'
          } formCountTime flex items-center justify-center `}
        >
          <span className={'block'}>{`${seconds}`?.charAt(0)}</span>
          <span className={'block'}>{`${seconds}`?.charAt(1)}</span>
        </div>
      )}
    </div>
  )
}

export default Countdown
